import { render, staticRenderFns } from "./ModalRevisions.vue?vue&type=template&id=32fedd04&lang=pug&"
import script from "./ModalRevisions.vue?vue&type=script&lang=js&"
export * from "./ModalRevisions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports